import React from 'react'
import { useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { Avatar, avatarAltTextGeneric, AvatarDetails } from '../../atoms/icons/Avatar'
import { Title } from '../../atoms/title/Title'
import { BodyTextSize, TitleSize } from '../../styles/typeStyles'
import { Flex1View } from '../../templates/content/CommonViews'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

const BackgroundContainer = styled(Flex1View)<{ backgroundColor: string }>(({ backgroundColor, theme }) => ({
  backgroundColor,
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  alignSelf: 'stretch',
  gap: theme.spacing['8px'],
}))

export type ZoomParticipantEmptyViewProps = {
  participantFirstName?: string
  participantName?: string
  avatarDetails?: AvatarDetails
  isFullscreen?: boolean
  participantTitle?: string
}

export const ZoomParticipantEmptyView: React.FC<ZoomParticipantEmptyViewProps> = ({
  participantFirstName,
  avatarDetails,
  isFullscreen,
  participantName,
  participantTitle,
}) => {
  const { colors } = useTheme() as ThemeType
  const { formatMessage } = useIntl()

  if (avatarDetails && isFullscreen) {
    return (
      <BackgroundContainer
        backgroundColor={colors.components.zoomVideoSession.background}
        testID={tID('ZoomParticipantEmptyView')}
      >
        <Avatar
          details={avatarDetails}
          size={112}
          accessibilityLabel={formatMessage(avatarAltTextGeneric, { name: avatarDetails.displayName })}
        />
        <Title text={participantName} size={TitleSize.LARGE} />
        <Title text={participantTitle} size={TitleSize.SMALL} />
      </BackgroundContainer>
    )
  }
  return (
    <BackgroundContainer
      backgroundColor={colors.components.zoomEmptyView.background}
      testID={tID('ZoomParticipantEmptyView')}
    >
      <BodyText size={BodyTextSize.SMALL} color={colors.components.zoomEmptyView.text} text={participantFirstName} />
    </BackgroundContainer>
  )
}
